module.exports = __webpack_public_path__ + "img/img_building.c44f8498.jpeg";